import React from 'react'
import styles from './Balance.module.scss'
import { Icon } from 'components/Icon/Icon'
import { Button } from 'components/Button/Button'
import { PopupBalance } from './PopupBalance/PopupBalance'

type Props = {
    amount: number,
    isBalanceZero?: boolean,
}

export function Balance(props: Props) {
    const [showPopup, setShowPopup] = React.useState(false)

    function closePopup() {
        setShowPopup(false)
    }

    function openPopup() {
        setShowPopup(true)
    }

    return (
        <>
            <div className={styles['wrapper']}>
                <div className={styles['content']}>
                    <div className={styles['balance']}>
                        <div className={styles['coinWrapp']}>
                            <Icon name='coin' />
                            <span className={styles['balance__label']}>Balance</span>
                        </div>
                        <span className={styles['balance__amount']}>${props.amount}</span>
                    </div>
                    <Button
                        size='s'
                        type='dark'
                        onClick={openPopup}
                        disabled={props.isBalanceZero}
                    >
                        Withdraw all
                    </Button>
                    {props.isBalanceZero ? (
                        <div className={styles['error']}>
                            <div>
                                <Icon name='attention' />
                            </div>
                            <span className={styles['error__text']}>Your balance is zero because you have no Patrons. Your Patrons' deposits will generate balance.</span>
                        </div>
                    ) : (
                        <span className={styles['info']}>Your Patrons' deposits will continue generating new earnings</span>
                    )}
                </div>
            </div>
            {showPopup && <PopupBalance onClose={closePopup} />}
        </>
    )
}

